import axios from '@axios'

export const state = {
    rates: [],
    currentPage: 1,
    perPage: 15,
    totalPages: 1,
    totalRecords: 0,
}

export const getters = {
    allRates: state => state.rates,
    currentPage: (state) => state.currentPage,
    perPage: state => state.perPage,
    totalPages: (state) => state.totalPages,
    totalRecords: (state) => state.totalRecords
}

export const mutations = {
    GET_RATES: (state, rate) => {
        if (!rate) return false
        state.rates = rate.rates
        state.currentPage = rate.page
        state.perPage = rate.perPage
        state.totalPages = rate.totalPages
        state.totalRecords = rate.totalRecords
    },

    CREATE_RATE: (state, rate) => {
        state.rates.unshift(rate)
    },

    REMOVE_RATE: (state, data) => {
        let rate = state.rates.filter((r) => {
            return r.id !== data.id
        })
        state.rates = rate
    },

    UPDATE_RATE: (state, data) => {
        if (!data) return false
        state.rates.forEach((element, index) => {
            if (element.id === data.id) {
                state.rates[index] = data
            }
        });
    },

}

export const actions = {
    async getRatesDropdown({ commit }, params = {}) {
        return axios.get(`/billing/rates`, { params: params })
    },

    async getRates({ commit, dispatch }, params = {}) {
        dispatch('layout/changeLoading', true, { root: true })

        await axios.get(`/billing/rates`, { params: params })
            .then((resp) => {
                if (resp.status === 200) {
                    commit(`GET_RATES`, resp.data)
                    dispatch('layout/changeLoading', false, { root: true })
                }
            })
            .catch(() => {
                console.error('Cannot communicate with API server')
            })
            .finally(() => {
                dispatch('layout/changeLoading', false, { root: true })
            })
    },
    async getRate({ commit }, rate) {
        return axios.get(`/billing/rate/${rate.id}`)
    },

    async getRateDetails({ commit }, detail) {
        return axios.get(`rate-detail/${detail.id}`)
    },

    async createRate({ commit }, rate) {
        let form = {}
        form.name = rate.name
        form.description = rate.description
        form.chargeType = rate.chargeType
        form.product = rate.product
        form.ratedetails = rate.ratedetails
        form.tax = rate.tax
        form.localDefaultPrice = rate.localDefaultPrice
        form.intDefaultPrice = rate.intDefaultPrice

        await axios.post(`/billing/rate`, form)
            .then((resp) => {
                if (resp.status === 201) {
                    commit('CREATE_RATE', resp.data)
                }
            })
    },

    async removeRate({ commit }, rate) {
        await axios.delete(`/billing/rate/${rate.id}`)
            .then((resp) => {
                if (resp.status === 204) {
                    commit('REMOVE_RATE', rate)
                }

            })
    },

    async updateRate({ commit }, rate = {}) {
        return axios.put(`/billing/rate`, rate)
    },

}
